/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

export type EnteredUserQualificationEnum =
  (typeof EnteredUserQualificationEnum)[keyof typeof EnteredUserQualificationEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnteredUserQualificationEnum = {
  PARAMEDIC_LICENSE: 'PARAMEDIC_LICENSE',
  OTHER: 'OTHER',
} as const;
